/* @ngInject */
function TaskListController ($scope, $rootScope, $state, $timeout, $translate, $location, $q, BoardsService, ModalService, TasksService, SocketService, SegmentService, WorkflowHeaderService, UdsModalService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))

  $scope.selectedOrder = {
    name: '',
    order: ''
  }
  $scope.listHeader = [
    { name: 'id', text: 'ID' },
    { name: 'status', text: $translate.instant('status') },
    { name: 'title', text: $translate.instant('title') },
    { name: 'priority', text: $translate.instant('priorityFilter') },
    { name: 'deliveryForecast', text: $translate.instant('deliveryForecast') },
    { name: 'assignee', text: $translate.instant('workflow.assignees') }
  ]

  $scope.filters = {
    isArchived: false
  }
  $scope.search = ''
  $scope.currentTop = 10
  $scope.tokensCount = 3
  $scope.indexPage = 0
  $scope.skipPagingTo = skipPagingTo
  $scope.loading = true

  const quickFilters = {
    assignees: null,
    authors: null,
    overdue: false
  }

  const api = {
    activate,
    getRequestDetailsDialogController,
    _getBoardTasks,
    _doDataFlow,
    _addSort,
    _connectSocket,
    _connectSocketWorkflow,
    _shouldHandleTask,
    _handleTaskCreated,
    _handleTaskUpdated,
    _handleTaskRemoved,
    _handleSocketReconnect,
    _openRequestDetailDialog,
    _handleChangeFilters,
    _getHeaderInfo,
    _onFilter,
    _onQuickFilters,
    _handleQuickFilter
  }
  this.getApi = () => api

  activate()

  function activate () {
    const url = $location.search()
    $scope.boardId = url.board

    $rootScope.getUser().then(user => {
      if (!$rootScope.isUserSysAdminAdminDesigner(user)) {
        $state.go('workflow.requests')
        return
      }

      if (!url.board) {
        $state.go('workflow.home')
        return
      }

      if (url.request) {
        api._openRequestDetailDialog(url.request)
      }

      if (url.term) {
        $scope.search = url.term
      }

      api._addSort(url)
      $timeout(() => {
        api._doDataFlow()
      }, 100, false)

      $scope.today = moment().format('YYYY-MM-DD')
      TasksService.getRequestsCount().then(count => { $scope.requestsCount = count })

      $timeout(() => {
        api._connectSocket($scope.boardId)
      }, 100, false)
    })
  }

  function _handleChangeFilters () {
    api._getBoardTasks($scope.boardId, $scope.currentTop, 0, $scope.filters, $scope.selectedOrder, $scope.search)
  }

  // Disconnect socket when user leave the page
  const deregisterStateChangeStart = $scope.$on('$stateChangeStart', () => {
    SocketService.disconnectSocket()
  })

  const deregisterOnBoardChange = $scope.$on('workflow-board-updated', (evt, data) => {
    $scope.board = data.board
  })

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    WorkflowHeaderService.openCreateTaskDialog(data?.createMore)
  })

  const deregisterSocketConnected = $rootScope.$on('socket-connected-successfully-Workflow', () => {
    SocketService.registerEvent('taskCreated', api._handleTaskCreated)
    SocketService.registerEvent('taskUpdated', api._handleTaskUpdated)
    SocketService.registerEvent('taskRemoved', api._handleTaskRemoved)
    SocketService.registerEvent('reconnect', api._handleSocketReconnect)
  })

  $scope.$on('$destroy', () => {
    deregisterStateChangeStart()
    deregisterOnBoardChange()
    deregisterSocketConnected()
    deregisterReopenCreateTaskDialog()
  })

  $scope.onSearchTasks = (searchTerm) => {
    $scope.search = searchTerm
    const url = $location.search()

    if (searchTerm) {
      $location.search({ ...url, term: searchTerm })
    } else {
      $location.search({ ...url, term: null })
    }

    api._getBoardTasks($scope.boardId, $scope.currentTop, 0, $scope.filters, $scope.selectedOrder, $scope.search)

    SegmentService.track('workflow-search', { place: $state.current.name, board: $scope.boardId, search_text: searchTerm })
  }

  $scope.sortListClick = function (field) {
    if ($scope.selectedOrder.name === field) {
      if ($scope.selectedOrder.order === 'ASC') {
        $scope.selectedOrder.order = 'DESC'
      } else if ($scope.selectedOrder.order === 'DESC') {
        $scope.selectedOrder.order = ''
        $scope.selectedOrder.name = ''
      }
    } else {
      $scope.selectedOrder.name = field
      $scope.selectedOrder.order = 'ASC'
    }

    const url = $location.search()
    const searchOptions = Object.assign({}, url, $scope.selectedOrder)

    $location.search(searchOptions)

    api._getBoardTasks($scope.boardId, $scope.currentTop, 0, $scope.filters, $scope.selectedOrder, $scope.search)
  }

  $scope.changeSortMobile = function (option) {
    if (option === $scope.selectedOrder.name) {
      $scope.selectedOrder.name = ''
    } else {
      $scope.selectedOrder.name = option
      $scope.selectedOrder.order = 'DESC'
    }

    const url = $location.search()
    const searchOptions = Object.assign({}, url, $scope.selectedOrder)

    $location.search(searchOptions)

    api._getBoardTasks($scope.boardId, $scope.currentTop, 0, $scope.filters, $scope.selectedOrder, $scope.search)
  }

  $scope.goToInbox = () => {
    const params = {
      from: $location.url()
    }

    $location.path('/workflow/requests').search(params)
  }

  function skipPagingTo (index) {
    $scope.indexPage = index
    api._getBoardTasks($scope.boardId, $scope.currentTop, $scope.currentTop * index, $scope.filters, $scope.selectedOrder, $scope.search)
  }

  function _getBoardTasks (boardId, top, skip, filters, sort, search) {
    BoardsService.getBoardTasks(boardId, top, skip, filters, sort, search).then(tasks => {
      $scope.tasks = tasks.rows
      $scope.tasksCount = parseInt(tasks.count)
    }).finally(() => {
      $scope.loading = false
    })
  }

  function _doDataFlow () {
    const url = $location.search()
    const showFinishedTasks = Array.isArray(url.taskStatus) ? url.taskStatus.some(status => status === 'DONE') : url.taskStatus === 'DONE'

    if (showFinishedTasks) {
      $scope.filters.taskStatus = url.taskStatus
    }

    BoardsService.getBoardById($scope.boardId).then(board => {
      $scope.board = board
      api._getHeaderInfo(board, showFinishedTasks)
    })
    api._getBoardTasks($scope.boardId, $scope.currentTop, 0, $scope.filters, $scope.selectedOrder, $scope.search)
  }

  function _addSort (url) {
    if (url.name && url.order) {
      $scope.selectedOrder.name = url.name
      $scope.selectedOrder.order = url.order
    }
  }

  /**
   * Called a board is loaded. Create a socket connection to that board
   *
   * @param {object} task Created task object
   */
  function _connectSocket (boardId) {
    const retryTime = 5000
    let attempts = 0

    api._connectSocketWorkflow(boardId)

    const retryInterval = setInterval(() => {
      if (!SocketService.isConnected() && attempts < 5) {
        attempts++
        api._connectSocketWorkflow(boardId)
      } else {
        clearInterval(retryInterval)
      }
    }, retryTime)
  }

  function _connectSocketWorkflow (boardId) {
    SocketService.disconnectSocket()
    SocketService.connectSocket('Workflow', { query: { boardId } })
  }

  /**
   * Checks if the task is valid to be handled in compared to the current taskTypes filter
   *
   * @param {object} task Task object
   * @returns {boolean}
   */
  function _shouldHandleTask ({ originType }) {
    const { taskTypes } = $scope.filters

    // Unselected task types always filter all type of tasks, including SUBTASK's.
    return !taskTypes || taskTypes === originType
  }

  /**
   * Called when a new task is created on board or when an request become a task
   * Recieve the created task as object
   *
   * @param {object} task Created task object
   */
  function _handleTaskCreated (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    $timeout(() => {
      task.createdNow = true
      $scope.tasks.unshift(task)
      $scope.tasksCount++
    }, 100)
  }

  /**
   * Called when a new task is created on board or when an request become a task
   * Recieve the created task as object
   *
   * @param {object} task Created task object
   */
  function _handleTaskRemoved (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    $timeout(() => {
      const taskIndex = $scope.tasks.findIndex(oldTask => task.taskId === oldTask.id)
      $scope.tasks.splice(taskIndex, 1)
      $scope.tasksCount--
    }, 100)
  }

  /**
   * Called when a some task info is updated
   * Recieve task object with updated data
   *
   * @param {object} task Updated task object
   */
  function _handleTaskUpdated (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    const taskIndex = $scope.tasks.findIndex(oldTask => task.id === oldTask.id)
    const taskItem = $scope.tasks[taskIndex]

    $timeout(() => {
      if (taskItem.priority !== task.priority) {
        $scope.tasks[taskIndex].priority = task.priority
      }

      if (taskItem.title !== task.title) {
        $scope.tasks[taskIndex].title = task.title
      }

      if (taskItem.assignees?.length !== task.assignees?.length) {
        $scope.tasks[taskIndex].assignees = task.assignees
      }

      if (taskItem.deliveryDate !== task.deliveryDate) {
        $scope.tasks[taskIndex].deliveryDate = task.deliveryDate
      }

      if (taskItem.status !== task.status) {
        $scope.tasks[taskIndex].status = task.status
      }
    }, 150)
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      ModalService.showModal({
        templateId: 'requestDetails.html',
        templateUrl: '/workflow/dialogs/request-details/request-details-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: RequestDetailsDialogController,
        data: {
          id
        }
      })
    })
  }

  // Reload the board after socket reconnect to assure syncrony
  function _handleSocketReconnect () {
    api._doDataFlow()
  }

  function _getHeaderInfo (board, showFinishedTasks = false) {
    $scope.headerNavigation = WorkflowHeaderService.getHeaderNavigation(board)
    WorkflowHeaderService.getHeaderToolbar($translate, board, { onSearch: $scope.onSearchTasks, onFilter: api._onFilter, onQuickFilters: api._onQuickFilters, value: $scope.search }, $rootScope.oUser.locale, $rootScope.isDesktop, showFinishedTasks).then(headerToolbar => {
      $scope.headerToolbar = headerToolbar
    })
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    $scope.filters = {
      ...$scope.filters,
      ...filters
    }

    WorkflowHeaderService.mergeQuickFilters($scope.filters, quickFilters)

    const url = $location.search()

    if (!$scope.filters.taskStatus?.length && url.taskStatus) {
      $location.search({ ...url, taskStatus: null })
    }

    api._handleChangeFilters()
  }

  function _onQuickFilters (filter) {
    if (filter === 'assignedToMe') {
      api._handleQuickFilter('assignees')
      quickFilters.assignees = quickFilters.assignees ? null : $rootScope.oUser.id
      quickFilters.authors = null
    }

    if (filter === 'createdByMe') {
      api._handleQuickFilter('authors')
      quickFilters.authors = quickFilters.authors ? null : $rootScope.oUser.id
      quickFilters.assignees = null
    }

    if (filter === 'overdue') {
      api._handleQuickFilter('overdue')
      quickFilters.overdue = !quickFilters.overdue
    }

    api._handleChangeFilters()
  }

  function _handleQuickFilter (filter) {
    $scope.filters.overdue = !!$scope.filters.overdue

    /**
     * Por algum motivo essa função é diferente da existente em kanban.controller.js.
     * Aqui ela lida com as props de quickFilters como se todas fossem arrays, quando na verdade não vai ser sempre o caso.
     * Como não quero quebrar nada, eu vou manter a função como está, mas irei fazer um early return para o caso de filter === 'overdue'.
     */
    if (filter === 'overdue') {
      $scope.filters.overdue = !$scope.filters.overdue
      return
    }

    if (!$scope.filters[filter]) {
      $scope.filters[filter] = []
    }

    const index = $scope.filters[filter].findIndex(item => item === $rootScope.oUser.id)

    if (index === -1) {
      $scope.filters[filter].push($rootScope.oUser.id)
    } else {
      $scope.filters[filter].splice(index, 1)
    }
  }
}

export { TaskListController }
